import { Typography } from "antd"

import styles from "./MonthRowName.module.less"

const { Text } = Typography

const MonthRowName = ({ month }) => (
  <Text className={styles.name}>
    {month?.month_name}
    {month?.month_state === "current" && <span className={styles.tag}>In progress</span>}
  </Text>
)

export default MonthRowName
